import { BarChart } from '@/components/charts/bar-chart'
import { customToolTip } from '@/components/charts/utils.ts'
import { Card, CardContent } from '@/components/ui/card'
import { CHART_COLORS } from '@/modules/tracking/new-subscriber-analysis/consts/color.ts'

interface Props {
  statistics: {
    subscribed: number
    unsubscribed: number
  }
}

export const SubscriptionLengthChart = ({ statistics }: Props) => {
  return (
    <Card className="w-full">
      <CardContent className="mx-auto flex h-80 max-w-xs justify-center gap-8 p-8 md:max-w-full">
        <BarChart
          data={
            !statistics.subscribed && !statistics.unsubscribed
              ? { labels: [], datasets: [] }
              : {
                  labels: ['Subscription Length'],
                  datasets: [
                    {
                      label: 'Subscribed',
                      data: [statistics.subscribed],
                      backgroundColor: [CHART_COLORS.TEAL],
                    },
                    {
                      label: 'Unsubscribed',
                      data: [statistics.unsubscribed],
                      backgroundColor: [CHART_COLORS.LIGHT_PINK],
                    },
                  ],
                }
          }
          options={{
            responsive: true,
            indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
              y: {
                grid: {
                  display: false,
                },
              },
            },
            datasets: {
              bar: {
                maxBarThickness: 28,
                borderRadius: 4,
                borderSkipped: false,
                categoryPercentage: 0.8,
              },
            },
            plugins: {
              tooltip: {
                ...customToolTip,
                xAlign: 'left',
                callbacks: {
                  title: function (context) {
                    return context[0].dataset.label
                  },
                  label: function (context) {
                    return `${context.parsed.x} Fans`
                  },
                },
              },
              legend: {
                display: true,
                align: 'start',
                position: 'top',
                fullSize: true,
              },
            },
          }}
          toggleOptions={{
            hideLabels: true,
          }}
        />
      </CardContent>
    </Card>
  )
}
